import React from 'react';
import { Grid,Box,Typography} from '@mui/material';
// import { ReactComponent as Oflag } from '../../StaticData/Svgs/Oflag.svg';
// import {ReactComponent as CompanyManagmentIcon} from '../../../../components/Dashboard/StaticsData/Icons/companyManagmentIcon1.svg';
// import {ReactComponent as PersonIcon} from '../../../../components/Dashboard/StaticsData/Icons/Person1.svg';
// import { ReactComponent as comp } from '../../StaticData/Svgs/Oflag.svg';
// import { useNavigate } from 'react-router-dom';
// import DyLinearProgress from '../../../../components/GlobalComponents/DyLinearProgress/DyLinearProgress';
// import { useSelector } from 'react-redux';
import TKCart from '../TKCart/TKCart';
// import { blue } from '@mui/material/colors';


const OCart = (props:any) => {
    // const navigate=useNavigate()
    let{obj,personPicture}=props  || {};
    let{name,responsibleName,score,keyResults,responsibleId}=obj  || {};
    // const tenantId=useSelector((state:any)=>state.meetings.profileTenantId);
    // const[allKeyResults,setAllKeyResults]=useState<any[]>();

    // let{keyResults}=obj || {};
    // useEffect(() => {
    //   setAllKeyResults(keyResults)
  
    // }, [keyResults])

  return (  
    
    <Grid container boxShadow={4} bgcolor={'#00387C'} borderRadius={4} p={2} >
        <Grid item xs={12}  >
        <Grid container >
        <Grid item xs={12}  >
        
        <Box 
        display={'flex'} 
        width={'100%'}
        alignItems={'start'}
         flexDirection={'row'}
        minHeight={'90px'} 
        justifyContent={'space-around'}  > 
        <Box>
        <Box px={0.5}>
              {
                <img src={
                  personPicture !== null && personPicture !== undefined &&
                  personPicture.filter((x:any)=>x.personId === responsibleId)[0] !== null &&
                  personPicture.filter((x:any)=>x.personId === responsibleId)[0]!== undefined
                  ?
                  personPicture.filter((x:any)=>x.personId === responsibleId)[0].pictureBase64String
                  :''
                } width={'60px'} style={{borderRadius:'50%'}} />
              }
        </Box>
        </Box>
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
          <Box display={'flex'} >
        <Typography  variant='body1' fontWeight={900} color={'#fff'}  fontSize={'15px'} >
            هدف: {
                name
            }
        </Typography>
        </Box>
        <Box display={'flex'} flexDirection={'row-reverse'} alignItems={'center'} textAlign={'center'} justifyContent={'center'} width={'100%'}>
        <Box >
        <Typography variant='button' fontWeight={900} color={'#fff'} fontSize={'13px'} > مسئول: {
            responsibleName
            }</Typography>
                    </Box>
            
        </Box>
        </Box>
        <Box 
        bgcolor={score>= 70 ?'#d5f7d4' : score <70 && score > 30 ? '#FFF8D0': '#FFEEE5 '}
        color={score>= 70 ?'#125610' : score <70 && score > 30 ? '#6B6440': '#993600 '}
        borderRadius={'50%'}
        boxShadow={10}
         display={'flex'}
         flexDirection={'column'}
         justifyContent={'end'} textAlign={'right'}>
         <Typography  px={2} py={0.5} textAlign={'center'} fontWeight={600}>
        امتیاز:  </Typography>
        <Typography textAlign={'center'} fontWeight={600}>{score}  </Typography>
        </Box>
        </Box>
        </Grid>
      </Grid>
        </Grid>
        <Grid item xs={12}  >
         {
          keyResults !== undefined && keyResults.length>0 &&  <Grid container  >
          <Grid item xs={12}  >
         
            <Grid container spacing={1} px={1} >
 
           {
            keyResults && keyResults.map((o:any,i:number)=>{
              return <Grid  item xs={12} sm={6}  >
               <Box
                    key={i}
                    sx={{
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "scale(1.05)",
                        backgroundColor: "withesmoke",
                        // boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)",
                        // borderRadius: "12px",
                      },
                      padding: "10px", // Add padding to ensure content isn't cut off during hover
                    }}
                  >
                <TKCart kr={o}   
                item={o}
                personPicture={personPicture}
                />
              </Box>
              </Grid>
            })
          }
           </Grid> 
          </Grid>
         </Grid>
         }
        </Grid>

        {/* <Grid xs={12}  >
        <Box width={'100%'} marginLeft={1}  display={'flex'} alignItems={'center'} justifyContent={'start'}>

        <Typography px={1} variant='button' fontWeight={900} color={'black'} >
                {
                    definitionLevelName
                }
        </Typography>
        </Box>
        </Grid> */}
    
        {/* <Grid item xs={12} >
             <Box width={'100%'}   >
                <DyLinearProgress value={evaluationPercentage}  />
             </Box>
             
        </Grid> */}

        {/* <Grid xs={12}> */}
        {/* <Box  display={'flex'} alignItems={'center'} justifyContent={'space-between'} textAlign={'center'}> */}
        {/* <Box  display={'flex'} alignItems={'center'} textAlign={'center'}  justifyContent={'center'}
        bgcolor={ objectivesStateName === "فعال"?'#D5f7D4':'#bfd3f5'}   width={'90px'} height={'28px'} borderRadius={3} >
        <Typography  color={objectivesStateName === "فعال"? 'green':'#3a82fc'} fontSize={'0.8rem'}  >  {
                objectivesStateName === "فعال"?'فعال':'پیش نویس'
            }
        </Typography>

        </Box> 
     */}
{/*         
        <Box display={'flex'} alignItems={'center'} textAlign={'center'}  justifyContent={'center'} bgcolor={'#FBF0EA'}  width={'95px'} height={'28px'} borderRadius={3} >

        <Typography color={'#F95700'} fontSize={'0.8rem'}>
          {keyResultCount}  نتیجه کلیدی 
        </Typography>
        </Box>  */}

      {/* </Box> */}
      {/* </Grid> */}
    </Grid>

  )
}

export default OCart